// extracted by mini-css-extract-plugin
export default {"selectChildrenWrapper":"Supports_selectChildrenWrapper__nMwbg"};